import {useEffect, useRef} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {buildEventsUrlSearchParams} from 'src/lib/portal-migration/events-search-params-sync'
import {FilterEventsType, SearchEventsType} from 'src/services/api'

type UseEventsUrlSyncParams = {
  filter: FilterEventsType
  search: SearchEventsType
  enabled?: boolean
}

export function useEventsUrlSync({filter, search, enabled = true}: UseEventsUrlSyncParams) {
  const navigate = useNavigate()
  const location = useLocation()
  const skipNextSyncRef = useRef(false)

  useEffect(() => {
    if (!enabled) return

    const nextSearch = buildEventsUrlSearchParams({filter, search})
    const currentSearch = location.search || ''

    if (nextSearch === currentSearch) return
    if (skipNextSyncRef.current) {
      skipNextSyncRef.current = false
      return
    }

    navigate({pathname: location.pathname, search: nextSearch || undefined}, {replace: true})
  }, [enabled, filter, search, location.pathname, location.search, navigate])
}
